export const SET_PACKAGE_NAME = 'DS_CHECKOUT/SET_PACKAGE_NAME';
export const SET_PACKAGE_SKU = 'DS_CHECKOUT/SET_PACKAGE_SKU';
